<template>
  <div>
    <div id="divprin">
      <b-container class="row no-gutters">
        <b-row class="justify-content-md-left">
        <b-col xs=10 lg=3 md=4 sm=5 align-self="start"><b-img :src="require('../assets/pergamin_logo_color2.svg')" fluid width="400" alt="Sistemas Pergamin"></b-img></b-col>
        <b-col class="tituloprin" ><h1 id="header">  Pergamin nfpoa</h1>       
         <b-col xs=10 lg=5 md=5 sm=10 left>
         <h3 class="descricao">Notas Fiscais de Serviço Eletrônicas para empresas de Porto Alegre - RS </h3>
         </b-col> 
         </b-col>
        </b-row>
      </b-container>
    </div>

    <b-navbar toggleable="md" type="light" variant="transparent" class="menudecima">
     <!-- <b-navbar-brand to="/"> 
     variant="transparent"
          <img src="../assets/lcelogo2.png" alt="Logo">
      </b-navbar-brand> -->

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item href="https://nf.poa.br/portal/index.php" target="_blank" rel="noopener noreferrer">
            Portal nfpoa <b-img :src="require('../assets/linkexterno.svg')" fluid width="20" alt="Ir para o portal nfpoa"></b-img>
          </b-nav-item>
          <b-nav-item href="http://pergamin.com.br" target="_blank" rel="noopener noreferrer">
            Sistemas Pergamin <b-img :src="require('../assets/linkexterno.svg')" fluid width="20" alt="Ir para pergamin.com.br"></b-img>
          </b-nav-item>
          <b-nav-item href="http://lucchese.com.br" target="_blank" rel="noopener noreferrer">
            Lucchese Computação e Estatística <b-img :src="require('../assets/linkexterno.svg')" fluid width="20" alt="Ir para lucchese.com.br"></b-img>
          </b-nav-item>
          
<!--           <b-nav-item-dropdown text="Soluções" left>
            <b-dropdown-item to="/pergamin">Pergamin Organic</b-dropdown-item>
            <b-dropdown-item to="/nfs">NFSePOA</b-dropdown-item>
            <b-dropdown-item to="/personalizadas">Soluções personalizadas</b-dropdown-item>
          </b-nav-item-dropdown> -->
         <!-- <b-nav-item to="/contato">Contato</b-nav-item> -->
          <!-- <b-nav-item href="http://pergamin.com.br">Pergamin.com.br</b-nav-item> -->
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
#header {
  text-align: left;
  font-size: 3rem;
  color: rgb(200, 200, 200);
}
#divprin {
  padding-top: 1vh;
  padding-left: 1vh;
  background-color: rgb(50,50,50);
}
#menudrop {
  font-family: Arial, Helvetica, sans-serif;
  text-align: left;
}
.descricao{
 /* color: rgb(150, 150, 150); */
 color: rgb(180, 180, 180);
 font-size: 0.9rem;
 font-style: normal;
 font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
 text-align: left;
}
.tituloprin{
 padding-left: 1vh;
 text-align: left;
}
.menudecima{
 border-bottom: 3px solid rgb(228, 230, 114);
 border-top: 3px solid rgb(228, 230, 114);
}

</style>